export type PresentationUrgency = 'now' | 'soon' | 'later';

export type PresentationPricebookCategory = 'repair' | 'tune_up' | 'diagnostic' | 'iaq' | 'custom';

export type PresentationPricebookItem = {
  id: string;
  code: string;
  category: PresentationPricebookCategory;
  customer_name: string;
  technical_name?: string;
  default_price_cents: number;
  default_urgency: PresentationUrgency;
  default_do_now: boolean;
  default_include_in_band_aid: boolean;
};

// Phase 1 MVP: a small, sane starter pricebook. Tech can override price or add custom items.
export const DEFAULT_PRESENTATION_PRICEBOOK: PresentationPricebookItem[] = [
  {
    id: 'diagnostic',
    code: 'DIAG-001',
    category: 'diagnostic',
    customer_name: 'Diagnostic & Safety Check',
    technical_name: 'Diagnostic Fee',
    default_price_cents: 9900,
    default_urgency: 'now',
    default_do_now: true,
    default_include_in_band_aid: true,
  },
  {
    id: 'tune-up',
    code: 'TUNE-001',
    category: 'tune_up',
    customer_name: 'System Tune-Up',
    technical_name: 'Maintenance Tune-Up',
    default_price_cents: 27500,
    default_urgency: 'now',
    default_do_now: true,
    default_include_in_band_aid: true,
  },
  {
    id: 'capacitor',
    code: 'CAP-001',
    category: 'repair',
    customer_name: 'Kickstarter Device (Capacitor)',
    technical_name: 'Run Capacitor',
    default_price_cents: 34500,
    default_urgency: 'now',
    default_do_now: true,
    default_include_in_band_aid: true,
  },
  {
    id: 'contactor',
    code: 'CON-001',
    category: 'repair',
    customer_name: 'AC Power Switch (Contactor)',
    technical_name: 'Contactor',
    default_price_cents: 34500,
    default_urgency: 'soon',
    default_do_now: true,
    default_include_in_band_aid: false,
  },
  {
    id: 'hard-start',
    code: 'HARD-001',
    category: 'repair',
    customer_name: 'Quick-Start Booster (Hard Start Kit)',
    technical_name: 'Hard Start Kit',
    default_price_cents: 39500,
    default_urgency: 'soon',
    default_do_now: false,
    default_include_in_band_aid: false,
  },
  {
    id: 'uv-light',
    code: 'IAQ-UV-001',
    category: 'iaq',
    customer_name: 'UV Light (Air Quality Upgrade)',
    technical_name: 'UV Light Installation',
    default_price_cents: 89500,
    default_urgency: 'later',
    default_do_now: false,
    default_include_in_band_aid: false,
  },
];

export function getDefaultPresentationPricebook(): PresentationPricebookItem[] {
  // Future: per-company overrides.
  return DEFAULT_PRESENTATION_PRICEBOOK;
}
